import React from 'react';
import PropTypes from 'prop-types';

import ResultItem from '../src/ResultItem';

const SearchItem = ({ item }) => (
    <a href={item.url} className='search-item'>
        {item.image &&
            <img className='search-item__image' alt={item.alternate} src={item.image} />
        }
        <div className='search-item__block'>
            <h3 className='search-item__title' dangerouslySetInnerHTML={{ __html: item.title }} />
            {item.body &&
                <p className='search-item__description' dangerouslySetInnerHTML={{ __html: item.body }} />
            }
            {item.url &&
                <span className='search-item__url'>
                    {document.location.protocol}&#47;&#47;{document.location.host}{item.url}
                </span>
            }
        </div>
    </a>
);

SearchItem.propTypes = {
    item: PropTypes.instanceOf(ResultItem).isRequired,
};

export default SearchItem;
